import axios from 'axios';

export default {
  getSettings: () => axios.get('/api/v1/settings'),
  updateSettings: data => axios.put('/api/v1/settings', data),
  updatePdfPresets: data => axios.patch('/api/v1/settings/pdf-templates', data),
  updateCompanyLogo: data => axios.patch('/api/v1/settings/company-logo', data),
  updateImportDefaultEncoding: data => axios.patch('/api/v1/settings/import-default-encoding', data)
};
